import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, heroImage, trackCheckout } from '../data/offer';
const highlights = ['Premium Teaching Library', '5 Strategic Bonuses', 'Instant Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-base" data-id="element-144" data-mp="4n1kkpc3c8rg">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-cream via-base to-base -z-10" data-id="element-145" data-mp="129qs1epkbdkp" />
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-146" data-mp="xb5w3rhcfg22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-147" data-mp="s9q6rn84undv">
          <div className="inline-block px-3 py-1 rounded-full border border-brand/30 bg-brand-soft text-brand-dark font-semibold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-148" data-mp="3d2tod9lewkej">
            Mindfulness & Meditation Teacher Ready
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight mb-4 sm:mb-6 text-ink" data-id="element-149" data-mp="3o6kgnlhm6i6p">
            Solve an entire year of mindfulness and meditation classes in just{' '}
            <span className="text-brand" data-id="element-150" data-mp="3e7uw1kyc2jmr">5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-151" data-mp="30h9dxygpedpx">
          <img src={heroImage} alt="Mindfulness & Meditation Teacher Ready — 150 ready-to-teach sessions, Session Finder and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-152" data-mp="2vjpyiv89ruwe" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-153" data-mp="s1rsao8pe6ua">
          <p className="text-sm sm:text-lg md:text-xl text-graphite leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-154" data-mp="ibgjana5x7gj">
            Complete Teaching Library with Session Finder and five bonus guides — ready to open,
            teach and inspire from today. Designed for mindfulness and meditation teachers guiding
            practitioners of all ages.
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-155" data-mp="112pwp7n20gde">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-156" data-mp="111525i0qoxfj">
              {ctaLabel}
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-graphite-light" data-id="element-157" data-mp="3hpsglavsi14o">
            {highlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-158" data-mp="21a4rlpufu83c">
                <CheckCircle size={14} className="text-brand" data-id="element-159" data-mp="269zj9vm1f1pg" />
                <span data-id="element-160" data-mp="268oeptkrppxa">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}